import { __assign, __read, __spread, __values } from "tslib";
import { useMemo } from 'react';
/**
 * Limits the number of nodes by going from the roots breadth first until we have desired number of nodes.
 * TODO: there is some possible perf gains as some of the processing is the same as in layout and so we do double
 *  the work.
 */
export function useNodeLimit(nodes, edges, limit) {
    return useMemo(function () {
        var e_1, _a;
        if (nodes.length <= limit) {
            return { nodes: nodes, edges: edges };
        }
        var edgesMap = edges.reduce(function (acc, e) {
            var _a;
            var sourceId = e.source;
            return __assign(__assign({}, acc), (_a = {}, _a[sourceId] = __spread((acc[sourceId] || []), [e]), _a));
        }, {});
        var nodesMap = nodes.reduce(function (acc, node) {
            var _a;
            return (__assign(__assign({}, acc), (_a = {}, _a[node.id] = node, _a)));
        }, {});
        var roots = nodes.filter(function (n) { return n.incoming === 0; });
        var newNodes = {};
        var stack = __spread(roots);
        while (Object.keys(newNodes).length < limit && stack.length > 0) {
            var current = stack.shift();
            if (newNodes[current.id]) {
                continue;
            }
            newNodes[current.id] = current;
            var edges_2 = edgesMap[current.id] || [];
            try {
                for (var edges_1 = (e_1 = void 0, __values(edges_2)), edges_1_1 = edges_1.next(); !edges_1_1.done; edges_1_1 = edges_1.next()) {
                    var edge = edges_1_1.value;
                    stack.push(nodesMap[edge.target]);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (edges_1_1 && !edges_1_1.done && (_a = edges_1.return)) _a.call(edges_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        var newEdges = edges.filter(function (e) { return newNodes[e.source] && newNodes[e.target]; });
        return { nodes: Object.values(newNodes), edges: newEdges };
    }, [edges, limit, nodes]);
}
//# sourceMappingURL=useNodeLimit.js.map